import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { style: {"margin":"0 15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_SideMenu = _resolveComponent("SideMenu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_Tabls1 = _resolveComponent("Tabls1")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 4 }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "logo"
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 16 }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("h2", null, "后台管理系统", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  span: 4,
                  class: "col-btn"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { onClick: _ctx.delToken }, {
                      default: _withCtx(() => [
                        _createTextVNode("退出登录" + _toDisplayString(_ctx.$store.state.name), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, { width: "200px" }, {
              default: _withCtx(() => [
                _createVNode(_component_SideMenu)
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(_component_Tabls1),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}